export default "__VITE_ASSET__e9ecfc45__"